import * as Yup from 'yup';
import { DictionaryMineralGroup } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryMineralGroup>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
